(function () {
  var nav = document.getElementById('pdp-sticky-nav');
  if (!nav) return;

  var links = Array.from(nav.querySelectorAll('[data-pdp-nav-link]'));
  var targets = links.reduce(function (acc, link) {
    var id = link.getAttribute('href').slice(1);
    var el = document.getElementById(id);
    if (el) acc.push({ el: el, link: link });
    return acc;
  }, []);

  if (!targets.length) return;

  // IntersectionObserver：零 scroll 监听
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      links.forEach(function (l) { l.classList.remove('is-active'); });
      var match = targets.find(function (t) { return t.el === entry.target; });
      if (match) {
        match.link.classList.add('is-active');
        // 自动滚动 nav，让激活项居中可见
        match.link.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    });
  }, { rootMargin: '-15% 0px -80% 0px', threshold: 0 });

  targets.forEach(function (t) { io.observe(t.el); });
})();
